import React, { forwardRef, useEffect, useState } from 'react'
import { useDitto } from '@ow/ditto-core'
import Cascader from './Cascader'

// 较少情况使用，只满足text类型查询
const Render = function ({ opts = {}, value, onChange }) {
  const { productSlugs, refSlug } = opts
  const { onFetchRemoteData, tbId } = useDitto()
  const [tbData, setTbData] = useState([])
  const [fields, setFields] = useState([])

  useEffect(() => {
    if (onFetchRemoteData && refSlug) {
      const ditto = onFetchRemoteData(null, refSlug)
      ditto.fetchTbData({ pageSize: 10000 }).then((data) => {
        setTbData(data)
      })
    }
  }, [])
  useEffect(() => {
    if (onFetchRemoteData) {
      const ditto = onFetchRemoteData(tbId)
      setFields(ditto.fields)
    }
  }, [])

  return (
    <div className="relative flex items-center flex-row">
      <Cascader
        productSlugs={productSlugs}
        fields={fields}
        data={tbData}
        defaultValue={value}
        onChange={onChange}
      />
    </div>
  )
}
export default forwardRef(Render)
